/* @flow */
// $FlowFixMe
import { RefObject, useEffect, useState } from "react";

let isIntersectionObserverAvailable = true;
if (
  !("IntersectionObserver" in window) ||
  !("IntersectionObserverEntry" in window) ||
  !("intersectionRatio" in window.IntersectionObserverEntry.prototype)
) {
  isIntersectionObserverAvailable = false; // Or load polyfill
}

export const useOnScreen = (
  ref: RefObject<HTMLElement | null>,
  rootMargin: string = "0px"
) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (!isIntersectionObserverAvailable) {
      setIntersecting(true);
      return;
    }
    const currentRef = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      observer.unobserve(currentRef);
    };
  }, [ref, rootMargin]); // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting;
};
